import {Pipe, PipeTransform} from '@angular/core';
import {RaceCommercialItem} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {transformValueAndCurrency} from "@utility";

@Pipe({
    name: 'raceCommercialItemsMinPriceFormat',
    standalone: false
})
export class RaceCommercialItemsMinPriceFormatPipe implements PipeTransform {

  constructor(private transloco: TranslocoService ) {
  }

  transform(raceCommercialItems:RaceCommercialItem[] | undefined, currencyLabel: string = ""): string | undefined {
    let minPrice:number|undefined =  this.getRaceCommercialItemsMinPrice(raceCommercialItems);
    return transformValueAndCurrency(minPrice, this.transloco.getActiveLang(), currencyLabel);
  }

  getRaceCommercialItemsMinPrice(raceCommercialItems:RaceCommercialItem[] | undefined): number|undefined {
    if (raceCommercialItems === undefined) {
      return undefined;
    } else if (raceCommercialItems.length === 0) {
      return undefined;
    } else {
      let minPrice = undefined;
      for (let raceCommercialItem of raceCommercialItems) {
        if (raceCommercialItem.priceConstantByPeriod === true) {
          if (minPrice === undefined) {
            minPrice = raceCommercialItem.price!;
          }
          if ((raceCommercialItem.price ?? 0) < minPrice) {
            minPrice = raceCommercialItem.price!;
          }
        } else if (raceCommercialItem.priceConstantByPeriod === false && raceCommercialItem.periods) {
          for (let period of raceCommercialItem.periods) {
            if (minPrice === undefined) {
              minPrice = period.price!;
            }
            if ((period.price ?? 0) < minPrice) {
              minPrice = period.price!;
            }
          }
        }
      }
      return minPrice;
    }
  }
}
